export interface GetCmResponsibleResponse {
  data: {
    id: number
    first_name: string
    last_name?: string | null
    avatar?: string | null
    email: string
    working_phone: string | null
    name?: string | null
  } | null
  code: number
}
